import { render, staticRenderFns } from "./PopupPage.vue?vue&type=template&id=63702164&scoped=true"
import script from "./PopupPage.vue?vue&type=script&lang=js"
export * from "./PopupPage.vue?vue&type=script&lang=js"
import style0 from "./PopupPage.vue?vue&type=style&index=0&id=63702164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63702164",
  null
  
)

export default component.exports